import { Link } from 'react-router-dom';

const TONE_ICONS = {
  purple: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="M8 12h8M12 8v8" strokeLinecap="round" />
    </svg>
  ),
  danger: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v5" strokeLinecap="round" />
      <circle cx="12" cy="16" r="0.8" fill="currentColor" stroke="none" />
    </svg>
  ),
  warning: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v5M8 12h8" strokeLinecap="round" />
    </svg>
  ),
  info: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="4" y="5" width="16" height="14" rx="2" />
      <path d="M8 9h8M8 13h5" strokeLinecap="round" />
    </svg>
  ),
  success: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="8" />
      <path d="M8.5 12.5l2.2 2.2 4.8-5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  default: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 19V5h16v14H4z" />
      <path d="M8 9h8M8 13h5" strokeLinecap="round" />
    </svg>
  ),
};

export function DashboardStatCard({ label, value, highlight, children, to, tone, hint, viewAll }) {
  const resolvedTone = tone || (highlight ? 'danger' : 'default');
  const className = `kpi-card kpi-card--${resolvedTone}${to ? ' kpi-card--link' : ''}`;
  const content = (
    <>
      <div className="kpi-card-top">
        <span className="kpi-card-icon" aria-hidden>
          {TONE_ICONS[resolvedTone] || TONE_ICONS.default}
        </span>
        <span className="kpi-card-label">{label}</span>
      </div>
      <div className="kpi-card-value">{value}</div>
      {children}
      {hint ? <div className="kpi-card-hint">{hint}</div> : null}
      {viewAll || to ? <div className="kpi-card-link">{viewAll || 'View all →'}</div> : null}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={className}>
        {content}
      </Link>
    );
  }

  return <div className={className}>{content}</div>;
}
